<script>
import Status from '../Status'
import Audio from '../Audio'
import Dropdown from '../../common/Dropdown'
import { invoiceMixins, ListsMixins, teamTaskMixins, urlQueriesMixins, userTeamMixins } from '../../../utils/mixins'
import ComboBox from '../form/formModules/ComboBox.vue'
import moocCourseProvider from '../../../services/mooc/course'
import PrintCertificatesModal from '../../mooc/issuanceOfCertificate/PrintCertificatesModal.vue'
import moment from 'jalali-moment'
import dadbanCourseProvider from '../../../services/dadban/course'

export default {
  mixins: [userTeamMixins, teamTaskMixins, invoiceMixins, ListsMixins, urlQueriesMixins],
  components: {
    Dropdown,
    Status,
    Audio,
    ComboBox,
    PrintCertificatesModal,
  },
  props: {
    striped: {
      type: Boolean,
      default: false,
    },
    checkedList: Array,
    url: {
      type: String,
    },
    selectRoute: {
      type: String,
      default: '',
    },
    imgStyle: {
      type: String,
    },
    imgClass: {
      type: String,
    },
    heightStyle: {
      type: String,
      default: '',
    },
    clickToChangeRoute: {
      default: true,
      type: Boolean,
    },
    isCrm: {
      default: false,
      type: Boolean,
    },
    fields: {
      default: [],
    },
    rows: {
      default: [],
    },
    fixedHeight: {
      type: Boolean,
      default: false,
    },
    invoice: {
      type: Boolean,
      default: false,
    },
    noNeedToChangeRoute: {
      type: Boolean,
      default: false,
    },
    productPrice: {
      type: Number,
    },
  },
  data() {
    return {
      loading: true,
      selectMode: 'single',
      certificateMode: {},
      selected: null,
      selectedRole: '',
      filter: null,
      filterOn: [],
      items: null,
      selectedId: 'کاربر',
      showUserNameSearch: false,
      showUserPhoneSearch: false,
      userNameSearch: '',
      userPhoneSearch: '',
      userRols: [
        { value: 'کاربر', key: 1 },
        { value: 'ادمین', key: 2 },
        { value: 'استاد', key: 3 },
        { value: 'منتور', key: 4 },
      ],
      selectedCheckBox: [],
    }
  },
  mounted() {
    if (!localStorage.getItem('query')) {
      localStorage.setItem('query', `?pageNumber=1&perPage=10`)
    }
    this.selectedCheckBox = this.checkedList
  },

  methods: {
    async submitOrder(id, order) {
      await dadbanCourseProvider.setOrder({
        packageId: +this.$route.params.packageId,
        courseId: id,
        order,
      })
    },
    async submitScore(id, score) {
      const req = await moocCourseProvider.setUserScore({
        id,
        score,
      })
    },
    fillRole(id) {
      return this.userRols.find((item) => item.key === +id)?.value
    },
    updateRole(e, rowId) {
      const data = {
        id: +rowId,
        productId: +this.$route.params.courseId || +this.$route.params.packageId,
        productType: this.$route.params.courseId ? 0 : 1,
        status: e.key,
      }
      if (data.status) {
        this.$emit('updateRole', data)
      }
    },
    findItems(array, fieldName) {
      return array.find((item) => item.fieldName === fieldName)
    },

    goDetail(row, index) {
      const route = this.$route
      const modal = this.$bvModal

      if (route.path === '/list/alltransactions') {
        try {
          const array = row.items
          const payload = {
            date: this.findItems(array, 'Date').value,
            price: this.findItems(array, 'NormalizePrice').value,
            fullName: this.findItems(array, 'FullName').value,
            SHABANumber: this.findItems(array, 'ShabaNumber').value,
            isIncreaseColor: this.findItems(array, 'IsIncreaseStatus').color,
            isIncreaseValue: this.findItems(array, 'IsIncreaseStatus').value,
            payDescription: this.findItems(array, 'PayDescription').value,
            referenceNumber: this.findItems(array, 'ReferenceNumber').value,
            manualPaymentUrl: this.findItems(array, 'ManualPaymentUrl').value,
            manualPaymentUrlName: this.findItems(array, 'ManualPaymentUrlName').value,
            manualPaymentUrlType: this.findItems(array, 'ManualPaymentUrlType').value,
            isIncreaseStatusColor: this.findItems(array, 'IsIncreaseStatus').color,
            isIncreaseStatusValue: this.findItems(array, 'IsIncreaseStatus').value,
            manualPaymentDescription: this.findItems(array, 'ManualPaymentDescription').value,
            id: this.findItems(array, 'Id').value,
            transactionId: +this.$route.params.transactionId,
            manualPaymentStatus: this.findItems(array, 'IsIncreaseStatus').value === 'در انتظار واریز ' ? false : true,
          }
          const route = this.$router.resolve(`/list/allbalancewithuserinfo/transactionDetail/${payload.id}`)
          localStorage.setItem('transactionDetail', JSON.stringify(payload))
        } catch (error) {
          console.log(error)
        }
      }
      if (route.name === 'userTransactionDetail') {
        try {
          const array = row.items
          const payload = {
            date: this.findItems(array, 'Date').value,
            price: this.findItems(array, 'NormalizePrice').value,
            fullName: this.findItems(array, 'FullName').value,
            SHABANumber: this.findItems(array, 'ShabaNumber').value,
            isIncreaseColor: this.findItems(array, 'IsIncrease').color,
            isIncreaseValue: this.findItems(array, 'IsIncrease').value,
            payDescription: this.findItems(array, 'PayDescription').value,
            referenceNumber: this.findItems(array, 'ReferenceNumber').value,
            manualPaymentUrl: this.findItems(array, 'ManualPaymentUrl').value,
            manualPaymentUrlName: this.findItems(array, 'ManualPaymentUrlName').value,
            manualPaymentUrlType: this.findItems(array, 'ManualPaymentUrlType').value,
            isIncreaseStatusColor: this.findItems(array, 'IsIncreaseStatus').color,
            isIncreaseStatusValue: this.findItems(array, 'IsIncreaseStatus').value,
            manualPaymentDescription: this.findItems(array, 'ManualPaymentDescription').value,
            id: this.findItems(array, 'Id').value,
            transactionId: +this.$route.params.transactionId,
            manualPaymentStatus: this.findItems(array, 'IsIncreaseStatus').value === 'در انتظار واریز ' ? false : true,
          }
          const route = this.$router.resolve({
            path: `/list/allbalancewithuserinfo/transactionDetail/${payload.id}`,
            query: this.$route.query,
          })
          window.open(route.href, '_blank')
          localStorage.setItem('transactionDetail', JSON.stringify(payload))
        } catch (error) {
          console.log(error)
        }
      }
      if (route.path === '/list/allbalancewithuserinfo') {
        const userId = this.rowsItems[index].items.find((item) => item.fieldName === 'UserId').value
        const fullName = row.items.find((item) => item.fieldName === 'FullName').value
        const walletType = row.items.find((item) => item.fieldName === 'Coin').value === 'تومان' ? 'TOMAN' : 'DADCOIN'

        localStorage.setItem('walletUserInformation', JSON.stringify({ userId: userId, userName: fullName, walletType }))
      }
      if (route.path.includes('/list/totalcomments')) localStorage.setItem('templateId', row.items[4].value)
      if (route.params.slug === 'universityreport') return
      if (route.params.slug === 'universitylicense') {
        row.items.reduce((obj, item) => {
          obj[item.fieldName] = item.value
          localStorage.setItem('certificateInformation', JSON.stringify(obj))
          return obj
        }, {})
      }
      if (route.name === 'mooc-issuance-certificate') {
        modal.show('certificateModal')
        this.certificateMode = row
      } else if (route.params.slug === 'homecategory') {
        modal.show('homeCategoryModal')
      } else if (['universitycategorypackage', 'universitycategorycourse'].includes(route.params.slug)) {
        modal.show('categoryModal')
      } else if (this.$route.path === '/list/manageusers') {
        const router = this.$router.resolve({ name: 'mooc-edit-users', params: { id: row.id } })

        window.open(router.href, '_blank')
      } else if (this.$route.path === '/list/allbalancewithuserinfo') {
        const userId = this.rowsItems[index].items.find((item) => item.fieldName === 'UserId').value
        const fullName = row.items.find((item) => item.fieldName === 'FullName').value
        const walletType = row.items.find((item) => item.fieldName === 'Coin').value === 'تومان' ? 'TOMAN' : 'DADCOIN'
        const router = this.$router.resolve({
          path: `/list/allbalancewithuserinfo/detail/${row.id}`,
          query: { userId, walletType, userName: fullName },
        })

        window.open(router.href, '_blank')
      } else if (!this.noNeedToChangeRoute) {
        if (this.invoice) {
          this.setSelectedRow({ row, index })
        } else {
          if (this.isCrm == false) {
            this.onRowSelected(row)
          } else {
            this.$router.push({ path: `/teamtask/${this.routeParam}/details/${row.key}` })
          }
        }
      }
      this.$emit('selectedRow', row)
    },
    addTab(payload) {
      return this.addTeamTaskTab({
        teamTaskTab: payload,
      })
    },
    setActiveTabName(payload) {
      return this.setActiveTab({
        activeTab: payload,
      })
    },
    clearUrlQueries() {
      // this.setSearchQuery('')
      // this.setCurrentPage(1)
      // this.setFields([])
      // this.setPageSize(10)
      this.setCleanQueries()
    },
    onRowSelected(items) {
      if (this.clickToChangeRoute === true) {
        this.clearUrlQueries()
        if (this.$route.params.slug === 'cryptowallet') {
          this.setSelectedRow({ items })
          this.$router.push({
            path: `/list/specificUserWalletTransactions/fromListsWallet/${items.items[7].value === 'تومان' ? 'toman' : items.items[7].value}/${items.items[6].value}`,
          })
          this.selected = items
          return
        } else {
          if (
            this.$route.path === `/list/specificUserWalletTransactions/fromListsWallet/${this.$route.params.slug}/${this.$route.params.id}` ||
            this.$route.path === `/list/specificUserWalletTransactions/fromUserManagement/${this.$route.params.slug}/${this.$route.params.id}`
          ) {
            this.$router.push({ path: `/list/${this.selectRoute}/${items.key}` })
          } else {
            if (
              [
                '/list/packages',
                '/list/courses',
                '/list/users',
                '/list/teachers',
                '/list/articles',
                '/list/ruleandregulation',
                '/list/adminstudents',
                '/list/mentors',
                '/list/discount',
                '/list/facultyuniversitycourses',
                '/list/universitycourses',
                '/list/facultyshortuniversitypackages',
                '/list/facultylonguniversitypackages',
                '/list/longuniversitypackages',
                '/list/shortuniversitypackages',
                '/list/posts',
                '/list/totalcomments',
                '/list/advertisings',
              ].includes(this.$route.path)
            ) {
              const route = this.$router.resolve({ path: `${this.selectRoute}/${items.key}` })
              localStorage.setItem('query', `?pageNumber=${this.$route.query.pageNumber || 1}&perPage=${this.$route.query.perPage || 10}`)
              window.open(route.href)
            } else if (this.$route.path === '/list/orders') {
              const route = this.$router.resolve({
                path: `${this.selectRoute}/${items.key}/?isInstallment=${items.items[8].value}&isCancel=${items.items.find((item) => item.fieldName === 'IsCancel').value}`,
              })
              localStorage.setItem('query', `?pageNumber=${this.$route.query.pageNumber || 1}&perPage=${this.$route.query.perPage || 10}`)
              window.open(route.href)
            } else if (['universitycategorypackage', 'universitycategorycourse'].includes(this.$route.params.slug)) {
              this.$emit('selectedRow', items)
            } else this.$router.push({ path: `${this.selectRoute}/${items.key}` })
          }
          this.selected = items
        }
      } else {
        this.addTab(items.key)
        this.setActiveTabName(items.key)
        const path = this.$route.path
        this.$router.push({ path: `${path}?navLink=${items.key}` })
      }
    },
    GridView() {
      this.$router.push({ path: '/teamtask-board' })
    },
    deleteItem(item) {
      this.$emit('deleteRow', item)
      this.$bvModal.hide(`deleteModal-${item}`)
    },
    hideSearch() {
      if (this.showUserNameSearch || this.showUserPhoneSearch) {
        this.showUserNameSearch = false
        this.showUserPhoneSearch = false
      }
    },
    fillCheckBox(e, data) {
      if (e) {
        this.selectedCheckBox.push(data)
      } else {
        const current = this.selectedCheckBox.indexOf(this.selectedCheckBox.find((item) => item.productId == data.productId && item.productType == data.productType))
        this.selectedCheckBox.splice(current, 1)
      }

      this.$emit('selected', this.selectedCheckBox)
    },
  },
  computed: {
    routeParam() {
      return this.$route.params.slug
    },
    routeName() {
      return this.$route.name
    },
    rowsItems() {
      let rows = []
      if (
        this.$route.name === 'courses-package' ||
        this.$route.name === 'course-prerequisites' ||
        this.$route.name === 'package-prerequisites' ||
        this.$route.name === 'course-users' ||
        this.$route.name === 'campaign-detail' ||
        ['universitycategorycourse', 'universitycategorypackage', 'homecategory', 'slider'].includes(this.$route.params.slug)
      ) {
        rows = this.rows.map((item) => {
          const hasDelete = item.items.find((obj) => obj.type === 'Delete')
          if (!hasDelete && this.productPrice === 0) {
            item.items.push({
              color: '',
              fieldName: 'Delete',
              id: null,
              size: 16.7,
              type: 'Delete',
              typeEnum: 0,
              value: 'fa-regular fa-circle-xmark',
            })
          }
          return item
        })
      } else if (this.$route.path === '/list/discount/add' || this.$route.path === '/list/discount/detail/' + this.$route.params.id) {
        rows = this.rows.map((item) => {
          const hasSelect = item.items.find((obj) => obj.type === 'Select')
          const value = { productType: 1, productId: 0 }
          const selectedValue = this.checkedList.find((i) => i.productId == item.id)
          item.items.forEach((item) => {
            if (item.fieldName === 'ProductId') {
              value.productId = +item.value
            }
            if (item.fieldName === 'ProductType' && item.value.includes('د')) {
              value.productType = 0
            }
          })
          if (!hasSelect) {
            item.items.push({
              color: '',
              fieldName: 'Select',
              id: null,
              size: 16.7,
              type: 'Select',
              typeEnum: 0,
              value,
              selectedValue: selectedValue && selectedValue.productId ? true : false,
            })
          }
          return item
        })
      } else rows = this.rows

      return rows
    },
    newFields() {
      const fields = this.fields
      if (
        this.$route.name === 'courses-package' ||
        this.$route.name === 'course-prerequisites' ||
        this.$route.name === 'package-prerequisites' ||
        this.$route.name === 'course-users' ||
        this.$route.name === 'campaign-detail'
      ) {
        const hasDelete = fields.find((obj) => obj.key === 'Delete')
        if (!hasDelete && this.productPrice === 0) {
          fields.push({
            index: fields.length + 1,
            order: fields.length + 1,
            key: 'Delete',
            label: '',
            type: 'Action',
            isCollection: false,
            size: 15,
          })
        }
      }
      if (this.$route.path === '/list/discount/add' || this.$route.path === '/list/discount/detail/' + this.$route.params.id) {
        const hasSelect = fields.find((obj) => obj.key === 'Select')
        if (!hasSelect) {
          fields.push({
            index: fields.length + 1,
            order: fields.length + 1,
            key: 'Select',
            label: 'انتخاب',
            type: 'Action',
            isCollection: false,
            size: 15,
          })
        }
      }

      return fields
    },
  },
  watch: {
    userNameSearch(c) {
      setTimeout(() => {
        this.$emit('updateUserSearch', c)
      }, 2000)
    },
    userPhoneSearch(c) {
      setTimeout(() => {
        this.$emit('updateUserSearch', c)
      }, 2000)
    },
  },
}
</script>

<template>
  <div class="mb-0" :class="fixedHeight === true ? 'topDivTable' : ''">
    <table class="table main-table">
      <thead class="mainThead" :class="fixedHeight === true ? 'theadFixed' : ''">
        <tr>
          <template v-for="col in newFields">
            <th v-if="col.type != 'Hidden'" :key="col.key" class="ellipsis" :style="`width:${col.size}%;${col.label === '#' ? 'font-size: 20px;' : ''}`">
              <span class="cell" data-bs-toggle="tooltip" :title="col.label">{{ col.label }}</span>

              <div v-if="$route.name === 'course-users' && col.label === 'تلفن'" class="arrow" @click="showUserPhoneSearch = true">
                <img :key="col.key" style="margin-right: -10px" src="../../../assets/images/dadbanan/table-down.svg" />
              </div>

              <div v-if="$route.name === 'course-users' && col.label === 'تلفن' && showUserPhoneSearch" class="search-box" v-click-outside="hideSearch">
                <input type="text" v-model="userPhoneSearch" placeholder="جستجو..." />
              </div>

              <div v-if="$route.name === 'course-users' && col.label === 'نام و نام خانوادگی'" class="arrow" @click="showUserNameSearch = true">
                <img :key="col.key" style="margin-right: 70px" src="../../../assets/images/dadbanan/table-down.svg" />
              </div>

              <div v-if="$route.name === 'course-users' && col.label === 'نام و نام خانوادگی' && showUserNameSearch" class="search-box" v-click-outside="hideSearch">
                <input type="text" v-model="userNameSearch" placeholder="جستجو..." />
              </div>
            </th>
          </template>
          <th v-if="['universitycategorypackage', 'universitycategorycourse', 'homecategory', 'slider'].includes(this.$route.params.slug)"></th>
        </tr>
      </thead>
      <tbody v-if="rows">
        <tr v-for="(row, index) in rowsItems" :key="index" @click="goDetail(row, index)" style="vertical-align: middle">
          <template v-for="data in row.items">
            <td v-if="data.type != 'Hidden'" :key="data.columnId" :style="`width:${data.size}%`" class="ellipsis">
              <span class="cell" v-if="data.type == 'DateTimeOffset' && data.value" data-bs-toggle="tooltip" :title="FormatedDate(data.value)">{{ FormatedDate(data.value) }}</span>
              <span class="cell" v-else-if="data.type == 'Date' && data.value" data-bs-toggle="tooltip" :title="convertDate(data.value)">{{ convertDate(data.value) }}</span>

              <span v-else-if="data.type == 'Price' && data.value" data-bs-toggle="tooltip" :title="Commafy(data.value)" class="dLTR cell">
                {{ Commafy(data.value) }}
              </span>
              <span class="cell" v-else-if="data.type == 'Status' && data.value"><Status :status="data" color="#ff0000" /></span>
              <span class="cell" v-else-if="data.type == 'Voice' && data.value"><Audio :file="data.value" /></span>
              <span class="cell" v-else-if="data.type == 'dropDown' && data.value"><Dropdown simpleDropdown :items="userRols" /></span>
              <p v-else-if="data.type == 'DropDown' && data.value" class="drop-down">
                <ComboBox :searchedData="userRols" :selectedValue="fillRole(data.value)" placeholder="نقش" @selectedItem="updateRole($event, row.id)" result="key" />
              </p>
              <img v-else-if="data.type == 'Modal'" src="@/assets/images/dadbanan/history.svg" />
              <span class="cell" v-else-if="data.type == 'TimeSpan' && data.value">{{ timeSpanConverter(data.value) }}</span>
              <div class="cell" v-else-if="data.type == 'Image'" style="top: 10px">
                <img
                  v-if="data.value"
                  :src="data.value"
                  :alt="data.type"
                  :class="
                    routeParam === 'user' || routeParam === 'users' || routeParam === 'cryptocurrency' || routeName === 'course-users'
                      ? 'userImg'
                      : routeName == 'transactions-fromUserManagement' || routeName == 'transactions-fromListsWallet' || routeParam == 'cryptotransaction'
                      ? 'transactionMode'
                      : 'productImg'
                  "
                />
                <template v-else>
                  <img
                    v-if="
                      routeParam === 'users' || routeParam === 'user' || routeName === 'course-users' || routeParam === 'manageusers' || $route.name === 'mooc-issuance-certificate'
                    "
                    src="../../../assets/images/users/default.png"
                    alt="avatar"
                    class="userImg"
                  />
                  <img v-else src="../../../assets/images/brandDefaultPicture.svg" alt="avatar" class="productImg" />
                </template>
              </div>
              <span class="cell" v-else-if="data.type == 'Color'">
                <span class="colorValue cell" v-if="data.value">{{ data.value }}</span>
                <div class="colorDiv" :style="`border: 1px solid ${data.color == '#ffffff' ? '#000' : data.color};background-color:${data.color};`"></div>
              </span>
              <span class="cell" v-else-if="data.type == 'Icon' && data.value"><i :class="`${data.value} fileStyle`" :style="`color:${data.color}`"></i></span>
              <span class="cell" v-else-if="data.type == 'Delete' && data.value" @click.stop="$bvModal.show(`deleteModal-${row.id}`)"
                ><i :class="`${data.value} fileStyle`" :style="`color:${data.color}`"></i
              ></span>
              <b-form-checkbox v-else-if="data.type == 'Select'" class="checkbox" v-model="data.selectedValue" @change="fillCheckBox($event, data.value)"></b-form-checkbox>
              <input
                v-model="data.value"
                class="cell score"
                v-else-if="data.type == 'Text' && data.fieldName == 'Score' && $route.path.includes('university')"
                type="text"
                placeholder="نمره"
                @keypress.enter="submitScore(+row.id, +data.value)"
                @change="submitScore(+row.id, +data.value)"
              />
              <input
                v-model="data.value"
                class="cell score"
                v-else-if="data.type == 'Text' && data.fieldName == 'InOrder' && $route.fullPath.includes(`/list/packages/${$route.params.packageId}/packagecourses`)"
                type="text"
                placeholder="ترتیب فعال بودن"
                @keypress.enter="submitOrder(+row.id, +data.value)"
                @change="submitOrder(+row.id, +data.value)"
              />
              <i v-else-if="data.type === 'Text' && data.fieldName === 'PrintLicense' && $route.name === 'mooc-issuance-certificate'" class="fa-regular fa-file-certificate"></i>
              <span class="cell" v-else-if="data.type == 'Text' && data.value" data-bs-toggle="tooltip" :title="data.value">{{ data.value }}</span>
              <hr class="customHR" v-else-if="data.type != 'Hidden'" />
            </td>
          </template>

          <b-modal :id="`deleteModal-${row.id}`" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
            <div class="error-wrapper">
              <div class="mb-4 text-center">
                <img src="@/assets/images/checked1.svg" />
              </div>
              <div class="error-title text-center">آیا از حذف این محتوا اطمینان دارید؟</div>
              <div class="mt-3 float-right w-100">
                <div class="d-flex align-items-center justify-content-center">
                  <b-button class="col-6" variant="secondary" block @click="$bvModal.hide(`deleteModal-${row.id}`)">خیر</b-button>
                  <b-button class="ms-2 col-6" variant="primary" block @click="deleteItem(row)">بله</b-button>
                </div>
              </div>
            </div>
          </b-modal>
        </tr>
      </tbody>
    </table>
    <div class="w-100 emptyTable" v-if="rows && rows.length == 0">
      <slot name="emptyTable"></slot>
    </div>
    <PrintCertificatesModal :certificateMode="certificateMode" />
  </div>
</template>
<style lang="scss" scoped>
::v-deep .emptyTable .preloader-component {
  height: 400px !important;
}
.customHR {
  margin: 0 !important;
  bottom: 10px;
  position: relative;
  height: 2px;
  background-color: #000 !important;
  opacity: 0.3;
  max-width: 50px;
}
.dLTR {
  direction: ltr !important;
}
.checkbox {
  font-size: 18px;
  margin-top: -15px;
}
table {
  width: 100%;
}
.ellipsis {
  position: relative;
}
.ellipsis:before {
  content: '&nbsp;';
  visibility: hidden;
}
.ellipsis .cell {
  position: absolute;
  left: 0px;
  right: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ellipsis {
  p {
    position: absolute;
    top: 10px;
  }
}
.ellipsis div .productImg,
.ellipsis div .userImg {
  top: 5px;
}
.filter {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.filterTitle {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #555555;
}
.globalFlex {
  display: flex;
  justify-content: center;
  align-items: center;
}
.filterOptions {
  margin-right: 10px;
  width: 86px;
  height: 37px;
  padding: 8px 15px;
  background: #3ea3fc;
  border-radius: 30px;
}
.filterText {
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  text-align: right;
  color: #ffffff;
}
.GridView {
  margin-right: 14px;
  cursor: pointer;
}
.imageTable {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px;
  width: 50px;
  height: 45px;
  background: #ffffff;
  border: 1px solid #f0f0f0;
  box-sizing: border-box;
}
.widthInherit {
  width: 36px;
  height: 36px;
}

.drop-down {
  width: 100px;
}
::v-deep .table thead th {
  align-items: center;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #555555;
}
::v-deep .table td {
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 21px;
  text-align: right;
  color: #555555;
  padding: 18px;
}
::v-deep .pointer {
  cursor: pointer !important;
}
.three-dot {
  width: 15px;
  height: 15px;
}
.main-table tbody tr:hover {
  cursor: pointer;
  background-color: #eee;
}
.topDivTable {
  height: 310px;
  overflow: auto;
  // overflow-x: hidden ;
}
/* Hide scrollbar for Chrome, Safari and Opera */
.topDivTable::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.topDivTable {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.theadFixed {
  position: sticky;
  top: 0;
  z-index: 10;
}
.productImg {
  border-radius: 4px !important;
  width: 45px;
  height: 37px;
}
.userImg {
  border-radius: 50% !important;
  width: 32px;
  height: 32px;
}
.userPic {
  font-size: 45px;
  color: #556ee6;
}
.w-40,
.w-img {
  width: 40px !important ;
  overflow: hidden;
  white-space: normal;
  word-wrap: break-word;
}
.w-110 {
  width: 110px !important ;
  overflow: hidden;
  white-space: normal;
  word-wrap: break-word;
}
.w-name {
  width: 350px !important ;
  overflow: hidden;
  white-space: normal;
  word-wrap: break-word;
}
.mainThead {
  background-color: #f8f9fa;
}
.colorDiv {
  width: 12px;
  height: 12px;
  border-radius: 1px;
  position: relative !important;
}
.fileStyle {
  font-size: 23px;
  font-weight: 100;
  padding: 1px;
}

.search-box {
  width: 284px;
  height: 71px;
  padding: 20px 10px;
  border: 2px solid #ffffff;
  box-shadow: 0px 0px 4px rgba(140, 140, 140, 0.3);
  border-radius: 4px;
  position: absolute;
  background: #fff;
  z-index: 3;
  input {
    width: 100%;
    border: 1px solid #eff2f7;
    border-radius: 3px;
    font-size: 13px;
    padding: 5px;
    outline: none;
  }
}

.arrow {
  cursor: pointer;
  display: inline-block;
  position: relative;
}

.checkbox {
  font-size: 18px;
  margin-top: -15px;
}

.fa-circle-xmark {
  display: flex;
  justify-content: flex-end;
  margin: 0.2rem 3rem;
}

.score {
  width: 60%;
  outline: none;
  border: 1px solid #cfcfcf;
  color: #555555;
  padding: 5px 10px;
  border-radius: 4px;
  top: 10px;
}

.disabled {
  opacity: 0.3;
  pointer-events: none;
}
</style>
